import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from 'src/app/shared/common/loading-bar/loading.service';

export const LoadingInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
	const loadingService = inject(LoadingService);

	loadingService.setLoadingStatus(true, req.url);

	return next(req).pipe(finalize(() => loadingService.setLoadingStatus(false, req.url)));
};
